import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { flushUserSession, getAuthUser, login } from "./auth";
import { flash422, useDispatch } from "@/shared/components/flash";
import axios from "axios";

export const LogInAs = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        window.opener?.postMessage({ type: 'ready' }, '*');
        
        const loginAshandler = async (event) => {
            const receivedData = event.data;
            const { access_token, organization_id, program_id, auth, user_id, role } = receivedData;
            const user = getAuthUser()
            if (!!user) {
                await flushUserSession();
            }
            if (!auth || !auth.id) {
                console.warn("Waiting for valid auth data...", auth);
                return;
            }
            const apiUrl = `/organization/${organization_id}/program/${program_id}/admin/${auth.id}/user/${user_id}/loginAsToProgram`;
            axios.post(apiUrl, {}, {
                headers: { "Authorization": `Bearer ${access_token}` }
            })
                .then((res) => {
                    if (res.status === 200) {
                        const currentUser = { ...res.data.user, loginAs: role };
                        login({
                            user: currentUser,
                            access_token,
                            program: res.data.program,
                            rootProgram: res.data.program,
                            organization: res.data.organization,
                            loginAsBanner: { auth_name: auth.name }
                        })
                            .then(() => {
                                setLoading(false);
                                window.location.href = '/';
                            });
                    }
                })
                .catch(err => {
                    setLoading(false);
                    flash422(dispatch, err.response.data);
                });
        };

        window.addEventListener('message', loginAshandler);
        return () => {
            window.removeEventListener('message', loginAshandler);
        };
    }, []);
    if (loading) {
        return (
            <div
                style={{
                    height: "100vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    fontSize: "20px",
                    color: "#333",
                }}
            >
                <div
                    style={{
                        width: "40px",
                        height: "40px",
                        border: "4px solid #ccc",
                        borderTopColor: "#000",
                        borderRadius: "50%",
                        animation: "spin 1s linear infinite",
                    }}
                ></div>

                <p style={{ marginTop: "12px" }}>Loading…</p>

                {/* Spinner keyframes */}
                <style>
                    {`
                        @keyframes spin {
                            to { transform: rotate(360deg); }
                        }
                    `}
                </style>
            </div>
        );

    }
    return null;
}

export default LogInAs;